import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
    DefaultDataService,
    DefaultDataServiceConfig,
    EntityOp,
    HttpUrlGenerator,
    QueryParams
} from '@ngrx/data';
import { Store } from '@ngrx/store';
import { LoggingService } from '../../shared/services/logging/logging.service';
import moment from 'moment';
import { FeeHistory } from './fee-history.model';
import { EfaactDataService } from '../efaact.data-service';

export const entityName = 'FeeSetupHist';

@Injectable()
export class FeeHistoryDataService extends EfaactDataService<FeeHistory> {
    constructor(
        http: HttpClient,
        httpUrlGenerator: HttpUrlGenerator,
        log: LoggingService,
        config: DefaultDataServiceConfig,
        store: Store
    ) {
        super(http, httpUrlGenerator, entityName, log, config, store);
    }

    mapItems(item: FeeHistory): FeeHistory {
        if (!item) {
            return;
        }
        return {
            ...item,
            id: item.FeeSetupID,
            FeeRetainPercentStartDate: moment(item.FeeRetainPercentStartDate).isValid() ? moment(item.FeeRetainPercentStartDate).toDate() : null
        };
    }
}
